import { Space } from 'antd';
import { useFormikContext } from 'formik';
import FormInput from 'components/new-ui/composed/formInput/FormInput';
import FormPhoneNumber from 'components/new-ui/composed/formPhoneNumber/FormPhoneNumber';
import { FieldLabel, FormCol, FormRow } from '../../Utils';
import { FormFields, FormValues } from '../../types';

const ContactDetailsForm = () => {
    const formik = useFormikContext<FormValues>();

    return (
        <Space direction="vertical" size={12} style={{ width: '100%' }}>
            <FormRow>
                <FormCol>
                    <FieldLabel required htmlFor={FormFields.ContactDetails.CONTACT_NAME}>
                        Contact Name
                    </FieldLabel>
                    <div>
                        <FormInput
                            inputStyles={{ maxWidth: '100%' }}
                            placeholder="Enter Contact Name"
                            fieldProps={formik.getFieldProps(FormFields.ContactDetails.CONTACT_NAME)}
                            fieldMeta={formik.getFieldMeta(FormFields.ContactDetails.CONTACT_NAME)}
                            fieldHelper={formik.getFieldHelpers(FormFields.ContactDetails.CONTACT_NAME)}
                        />
                    </div>
                </FormCol>
                <FormCol>
                    <FieldLabel required htmlFor={FormFields.ContactDetails.EMAIL}>
                        Email Address
                    </FieldLabel>
                    <div>
                        <FormInput
                            inputStyles={{ maxWidth: '100%' }}
                            placeholder="Enter Email Address"
                            fieldProps={formik.getFieldProps(FormFields.ContactDetails.EMAIL)}
                            fieldMeta={formik.getFieldMeta(FormFields.ContactDetails.EMAIL)}
                            fieldHelper={formik.getFieldHelpers(FormFields.ContactDetails.EMAIL)}
                        />
                    </div>
                </FormCol>
            </FormRow>

            <FormRow>
                <FormCol>
                    <div style={{ width: '100%' }}>
                        <FormPhoneNumber
                            phoneNumberFieldProps={formik.getFieldProps(FormFields.ContactDetails.PHONE_NUMBER)}
                            phoneNumberFieldMeta={formik.getFieldMeta(FormFields.ContactDetails.PHONE_NUMBER)}
                            phoneNumberFieldHelpers={formik.getFieldHelpers(FormFields.ContactDetails.PHONE_NUMBER)}
                            codeFieldProps={formik.getFieldProps(FormFields.ContactDetails.PHONE_CODE)}
                            codeFieldMeta={formik.getFieldMeta(FormFields.ContactDetails.PHONE_CODE)}
                            codeFieldHelpers={formik.getFieldHelpers(FormFields.ContactDetails.PHONE_CODE)}
                        />
                    </div>
                </FormCol>
            </FormRow>
        </Space>
    );
};

export default ContactDetailsForm;
